import styled from 'styled-components';

export interface SubTitleImageProps {
  subTitle: string;
  imageUrl: string;
  imageAltText?: string;
  className?: string;
}
const SubTitleImageContainer = styled.div``;

const Subtitle = styled.p`
  ${({ theme }) => theme.fontSize.B10};
  color: ${({ theme }) => theme.colors.GREY};
  text-align: center;
`;

function SubTitleImage({
  subTitle,
  imageUrl,
  imageAltText,
  className,
}: SubTitleImageProps) {
  return (
    <SubTitleImageContainer className={className}>
      <Subtitle>{subTitle}</Subtitle>
      <img src={imageUrl} alt={imageAltText} />
    </SubTitleImageContainer>
  );
}

export { SubTitleImage };
